import { toggleAdvertiserDisclosure } from "../../bladejs/toggle-advertiser-disclosure";

toggleAdvertiserDisclosure();
